<template>
  <el-dialog title="Envoyer un email" :visible.sync="visible" :close-on-click-modal="false" width="50%">
    <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">
      <div style="position: absolute; top: 20px; right: 50px;" v-if="advanced">
        Design :
        <el-select size="mini" clearable v-model="form.options.view" placeholder="Choix d'un design de mail">
          <el-option label="Devis B2B - Simple" value="clean-devis-b2b"></el-option>
          <el-option label="Devis B2B" value="devis-b2b"></el-option>
        </el-select>
        <span style="margin: 10px;"></span>
        Modèle :
        <el-select size="mini" clearable v-model="template" placeholder="Choix d'un modèle de mail">
          <el-option label="Envoi de factures" value="SEND_INVOICES"></el-option>
        </el-select>
      </div>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="from" label="Expéditeur" v-if="advanced">
            <el-input placeholder="Expéditeur de l'email" v-model="form.from"></el-input>
          </el-form-item>
          <el-form-item prop="attachments" label="Pièces jointes">
            <el-tag :key="url" v-for="(url, name) in form.attachments">
              {{ name }}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="to" label="Destinataire">
            <tag-select :value="form.to"></tag-select>
          </el-form-item>
          <el-form-item prop="cc" label="Copie" v-if="advanced">
            <tag-select :value="form.cc"></tag-select>
          </el-form-item>
          <el-form-item prop="bcc" label="Copie cachée" v-if="advanced">
            <tag-select :value="form.bcc"></tag-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="subject" label="Sujet">
        <el-input placeholder="Saisissez le titre de l'email" v-model="form.subject"></el-input>
      </el-form-item>
      <el-form-item prop="message" label="Contenu du message">
        <el-input type="textarea" autosize placeholder="Saisissez le contenu de votre email" v-model="form.message"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="pull-left" type="text" @click="advanced = !advanced">Options avancées</el-button>
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button type="success" :loading="submissionLoading" v-on:click="submit()">Envoyer le mail</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import _ from 'lodash'
  import TagSelect from "../Entities/Selects/TagSelect.vue"

  export default {
    components: {TagSelect},
    name: 'email-modal',
    data () {
      return {
        visible: false,
        advanced: false,
        submissionLoading: false,
        fields: {
          validation: {

          }
        },
        template: '',
        form: {
          options: {
            view: 'layouts.clean-devis-b2b',
          },
          from: '',
          to: [],
          cc: [],
          bcc: [],
          subject: '',
          message: '',
          attachments: {}
        }
      }
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      }
    },
    mounted () {
      let self = this

      this.$model.email.on('create', ({item}) => {
        self.load(item)
        self.visible = true
      })
    },
    watch: {
      template (val) {
        this.form.subject = this.getSubject(val)
        this.form.message = 'Bonjour,' + "\n\n" + this.getMessage(val) + "\n\n" + 'Cordialement.' + "\n\n" + '— ' + this.user.name + ' de l\'équipe Devis B2B'
      },
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    methods: {
      getSubject (type) {
        if (type === 'SEND_INVOICES') {
          return 'Factures impayées en pièce jointe'
        }
      },
      getMessage (type) {
        if (type === 'SEND_INVOICES') {
          return 'Vous trouverez ci-joint les factures en attente de règlement à ce jour. Je compte sur vous pour faire le nécessaire afin de rétablir la situation.'
        }
      },
      reset () {
        this.form = this.$options.data.apply(this).form
        this.$refs['form'].resetFields()
        this.template = null
      },
      load (item) {
        if (item) {
          this.form.from = this.user.email
          if (item.template !== null) this.template = item.template
          if (item.from) this.form.from = item.from
          if (item.to) this.form.to = item.to
          if (item.cc) this.form.cc = item.cc
          if (item.bcc) this.form.bcc = item.bcc
          if (item.subject) this.form.subject = item.subject
          if (item.message) this.form.message = item.message
          if (item.attachments) this.form.attachments = item.attachments
        }
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            self.submissionLoading = true
            self.$nexus.post('notification', 'notify/email', self.form).then(() => {
              self.submissionLoading = false
              self.visible = false
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmailModal.vue?5b220a71